
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment convertir gratuitement une image WebP en JPEG ou PNG",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Apprenez à convertir facilement et gratuitement vos images WebP en formats JPEG ou PNG grâce à des outils en ligne et des astuces pratiques.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Comment convertir gratuitement une image WebP en JPEG ou PNG",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Apprenez à convertir facilement et gratuitement vos images WebP en formats JPEG ou PNG grâce à des outils en ligne et des astuces pratiques.",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-apropos.jpg"),
        // },
      ],
    };
  },
};
